import { MainPadding, MainContainerForm } from "../../../../styles/Main.styles";
import { useParams } from "react-router";
import Form from "../../form/paymentMethod/Form";

export default function CreationPaymentMethod() {
  const { idPaymentMethod } = useParams();

  return (
    <MainPadding>
      <MainContainerForm>
        <Form idPaymentMethod={idPaymentMethod} />
      </MainContainerForm>
    </MainPadding>
  );
}
